import React from 'react';
import { useState } from 'react';
import * as API from '../../appAPI/api';
import { randomID } from '../../helper_functions/helper_functions';

const StartNewDay = ({ assistantPassword, currentOrders, employees }) => {
  const [error, setError] = useState('')

  const handleNewDay = (e) => {
    e.preventDefault();
    let pass = document.getElementById('newDayPass');
    if (pass.value === assistantPassword) {

      if (currentOrders.length <= 0) {setError('Start your day first'); return}

      for (let x of currentOrders) {
        if (["pending", 'running', 'warning'].includes(x.state)) {
          setError('Some orders are not completed')
          return;
        }
        if (x.state === 'fulfilled') {
          for (let y of employees) {
              if (y.id === x.employer) {
                console.log(currentOrders)
              setError(`( ${y.name} ) hasn't finished yet`)
              return;
            }
          }
          
        }
      }

      if (sessionStorage.clientInfo.length) {
        console.log('clients')
        let clients = JSON.parse(sessionStorage.clientInfo)
        sessionStorage.clientInfo = ''
        API.startNewDay({clients})
      }
      if (currentOrders.length) {
        let po = sessionStorage.previousOrders ?  JSON.parse(sessionStorage.previousOrders).filter((x) => {
          let date_1 = new Date(x.date);
          let date_2 = new Date();
          let difference = date_2.getTime() - date_1.getTime();
          let TotalDays = Math.ceil(difference / (1000 * 3600 * 24));
          
          return TotalDays <= 7
        }) : [];

        let newCurrentOrders = [...currentOrders].map((o) => {
          o.employee = employees.filter((e) => (e.id === o.employer))[0].name
          o.x = 0
          return o
        })
        po.push(...newCurrentOrders);
        sessionStorage.previousOrders = JSON.stringify(po);
      }
      
      if (sessionStorage.employeesAndvehicles.length) {
        const data = JSON.parse(sessionStorage.employeesAndvehicles);
        let vehicles = data.vehicles;
        
        let dayData = {
          rounds: [],
          expenses: [],
          date: new Date(),
          id: randomID()
        }

        for (let v of vehicles) {
          if (v.finishedOrdersContainer.length) {
            for (let y of v.finishedOrdersContainer) {
              let obj = {
                "numOfOrders": y.orders.length,
                "employerMoney": y.employerMoney,
                "systemTotalPrice": y.systemTotalPrice,
                "employerInputPrice": y.employerInputPrice,
                "startedAt": y.startedAt,
                "workingHours": y.workingHours,
                "roundID": y.roundID,
                "date": y.date,
                "vehicle": {name: v.name, id: v.id},
                "employer": y.employer
              }
              dayData.rounds.push(obj)
            }
            dayData.expenses.push({...v.expenses, id: v.id})
          }
        }
        (async () => {
          const daysDB = await API.getAllData()
          const ev = daysDB["employees-vehicles"];
          ev.push(dayData)
          console.log(ev)
          API.setAllData(ev)
          sessionStorage.employeesAndvehicles = '';
          window.location.reload(false);
        })()
      }

      sessionStorage.currentOrders = "[]"
      setError('');
    }else {
      setError('Wrong Password')
    }
  }

  return (
    <form className="start-new-day" onSubmit={(e) => handleNewDay(e)}>
      <h2>Start a New Day !</h2>
        <br />
        {error && <p className='error-massage'>{error}</p>}
        <br />
        <input 
          type='password'
          placeholder="demo password 1 "
          required
          id='newDayPass'
          />
          <br />
          <br />
      <button>OK</button>
    </form>
  )
}

export default StartNewDay;